import React from "react";
import ContactItem from "../components/Contact/ContactItem";

const ContactPage = () => {
  return <ContactItem />;
};

export default ContactPage;
